import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateCategoryCustomerSearch = () => {
  const categoryCustomerSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/category-customer/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { categoryCustomerSearch }
}

export default InteractorCorporateCategoryCustomerSearch
